import { apiFetch } from '../apiFetch'

export const getDungeonSaves = () =>
  apiFetch({ path: '/saves' })

export const createDungeonSave = (data) =>
  apiFetch({ path: '/saves', method: 'POST', payload: data })

export const updateDungeonSave = (saveId, data) =>
  apiFetch({ path: `/saves/${saveId}`, method: 'PUT', payload: data })

export const deleteDungeonSave = (saveId) =>
  apiFetch({ path: `/saves/${saveId}`, method: 'DELETE' })
